'use client'

import React, { FC, ReactElement } from 'react'
import styles from './InscriptionText.module.css'
import useSWRImmutable from 'swr/immutable'
import { fetcher } from '@/utils/fetcher'
import { CDN_URL, CDN_PREVIEW_URL } from '@/utils/constants'
import classNames from 'classnames'
import { getBrc721eImageUrl } from '@/utils/brc721e-image'

const InscriptionJson: FC<{
	inscriptionId: string
	className?: string
	imageClassName?: string
	isDetail?: boolean
}> = (props): ReactElement => {
	const { data } = useSWRImmutable(`${CDN_URL}/${props.inscriptionId}`, fetcher)

	if (data?.credentialSubject?.image) {
		if (props.isDetail) {
			return (
				<>
					<img
						src={data?.credentialSubject?.image}
						loading="lazy"
						className={classNames(styles.root, {
							[(props.className as any)]: !!props.className,
							[(props.imageClassName as any)]: !!props.imageClassName
						})}
						alt={data?.credentialSubject?.name || 'Inscription'}
					/>
					<div className={classNames(styles.root, { [(props.className as any)]: !!props.className })}>
						{JSON.stringify(data, null, 2)}
					</div>
				</>
			)
		}

		return (
			<img
				src={data?.credentialSubject?.image}
				className={classNames({
					[(props.className as any)]: !!props.className,
					[(props.imageClassName as any)]: !!props.imageClassName
				})}
				alt={data?.credentialSubject?.name || 'Inscription'}
			/>
		)
	}

	if (data?.p === 'gen-brc-721' && data?.op === 'mint') {
		return (
			<img
				src={`${CDN_PREVIEW_URL}/${props.inscriptionId}`}
				loading="lazy"
				className={classNames({
					[(props?.className as any)]: !!props?.className,
					[(props?.imageClassName as any)]: !!props?.imageClassName
				})}
				alt="Inscription"
			/>
		)
	}

	if (data?.p === 'brc-721e') {
		return (
			<img
				src={getBrc721eImageUrl(data) || `${CDN_PREVIEW_URL}/${props.inscriptionId}`}
				loading="lazy"
				className={classNames({
					[(props?.className as any)]: !!props?.className,
					[(props?.imageClassName as any)]: !!props?.imageClassName
				})}
				alt="Inscription"
			/>
		)
	}

	return (
		<div className={classNames(styles.root, { [(props.className as any)]: !!props.className })}>
			{JSON.stringify(data, null, 2)}
		</div>
	)
}

export default InscriptionJson
